import React from "react";
import { NavLink } from "react-router-dom";

export class CookiePopUp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            wmUrl: casino.utils.getURLParameter('wm') ? `?wm=${casino.utils.getURLParameter('wm')}` : ''
        };
        this.acceptNecessaryCookies = this.acceptNecessaryCookies.bind(this);
        this.acceptAllCookies = this.acceptAllCookies.bind(this);
    }
    
    acceptNecessaryCookies() {
        casino.utils.setCookie("cookie_consent", 1, 365);

        this.props.showCookiePopUpFn(false);
    }

    acceptAllCookies() {
        casino.utils.setCookie("cookie_consent", 1, 365);
        casino.utils.setCookie("marketing", 1, 365);
        casino.utils.setCookie("analytic", 1, 365);
        //casino.utils.setCookie("visitor", casino.utils.uuidv4(), 365);

        //Load GTM
        casino.utils.loadGTMScript();
        //Load Frosmo
        //casino.utils.loadFrosmoScript();
        //Load CrazyEgg
        /*casino.utils.loadCrazyEggSctipt();*/
        casino.utils.loadMSClaritySctipt();

        //Check Affiliate URL link
        //Commented out, see https://supersport.atlassian.net/browse/SCCM-1848?focusedCommentId=57653
        //var wm_param = casino.utils.getURLParameter('wm');
        //if (wm_param !== undefined && wm_param !== 'undefined' && wm_param !== '') {
        //    casino.utils.setCookie("affiliate", wm_param, 30);
        //}

        this.props.showCookiePopUpFn(false);
    }

    render() {
        return <>
            <div className="cookie-popup-overlay"></div>
            <div id="cookie-popup">
                <div className="top-part">
                    <div><img src='content/images/assets/cookie.png' /></div>
                    <div>
                        <h4 className="cookie-title">Postavke kolačića</h4>
                        <p className="cookie-desc">
                            U svrhu pružanja boljeg korisničkog iskustva, Super sport koristi kolačiće (cookies).
                            Klikom na <NavLink to={"/cookie-policy" + this.state.wmUrl}>Postavke</NavLink> možeš postaviti njihova ograničenja,
                            a detaljne informacije pronađi u dokumentu <a href="https://mcasino.supersport.hr/pravila/politika-kolacica">Politika kolačića</a>.
                        </p>
                    </div>
                </div>
                <div className="cookie-actions">
                    <button className="cookie-btn blue" onClick={this.acceptAllCookies}>Prihvati sve</button>
                    <button className="cookie-btn white" onClick={this.acceptNecessaryCookies}>Prihvati nužne</button>
                </div>
            </div>
        </>
    }
}